<template>
	<div class="home-user">
		<div class="page-wrapper">
			<VContainer
				tag="header"
			>
				<VRow align-content="center">
					<VCol
						cols="12"
						md="6"
						class="d-flex flex-column banner-left"
						:class="{
							'banner-left--gap': isSmAndDown
						}"
					>
						<VCardText
							:class="isSmAndDown ? 'text-center font-weight-bold align-self-center w-100' : 'align-self-start'"
							class="text-top-heading"
						>
							{{ $t(`views.homeUser.${userType}.bannerLabel`) }}
						</VCardText>
						<VCardTitle
							tag="h1"
							class="word-break"
							:class="isSmAndDown ? 'text-h5 line-height-normal text-center' : 'text-h4'"
						>
							{{ $t(`views.homeUser.${userType}.title`) }}
						</VCardTitle>
						<VCardText
							tag="p"
							:class="isSmAndDown ? 'text-body-1 text-center' : 'text-body-1'"
						>
							{{ $t('views.homeUser.common.banner.subText') }}
						</VCardText>
						<VRow
							v-if="userType !== 'employeur'"
							align-content="center"
						>
							<VCol
								cols="12"
								md="6"
								:class="isSmAndDown ? 'd-flex justify-center' : ''"
							>
								<VBtn
									class="primary mr-2"
									:to="signUpUri"
								>
									{{ $t('views.homeUser.common.banner.signup') }}
								</VBtn>
								<VBtn
									outlined
									:to="signInUri"
								>
									{{ $t('views.homeUser.common.banner.signin') }}
								</VBtn>
							</VCol>
						</VRow>
					</VCol>
					<VCol
						cols="12"
						md="6"
						class="d-flex flex-column align-end banner-right"
					>
						<iframe
							v-if="userType !== 'employeur'"
							width="560"
							height="315"
							src="https://www.youtube.com/embed/6fTrQWZA6Ws?si=2FYgWcF1m3Ij121q&amp;start=0"
							title="Le Questionnaire Risques Professionnels"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerpolicy="strict-origin-when-cross-origin"
							allowfullscreen
						/>
						<ConnexionMCE
							v-else
						/>
					</VCol>
				</VRow>
				<VRow class="my-16">
					<VCol>
						<VCard
							flat
							class="pa-4 border-primary"
							color="#E7ECF5"
						>
							<div class="d-flex align-start mb-3">
								<VCardTitle class="text-h6 font-weight-bold primary--text word-break pa-0">
									<VIcon
										color="primary"
										size="20px"
										class="mr-2"
									>
										{{ emailIcon }}
									</VIcon>
									{{ $t('views.homeUser.common.accessInstruction.title') }}
								</VCardTitle>
							</div>
							<VCardText class="text-body-1 text--primary py-0">
								<template v-if="!isEmployeurParticulier">
									<div class="mb-2">
										<strong>1. {{ $t('views.homeUser.common.accessInstruction.hasAccount') }}</strong> :
										{{ accessInstruction(true) }}
									</div>
									<div>
										<strong>2. {{ $t('views.homeUser.common.accessInstruction.noAccount') }}</strong> :
										{{ accessInstruction(false) }}
									</div>
								</template>
								<template v-else>
									<div class="mb-2">
										{{ $t('views.homeUser.employeur-particulier.accessInstruction') }}
									</div>
								</template>
							</VCardText>
						</VCard>
					</Vcol>
				</VRow>
			</VContainer>
			<VContainer tag="main">
				<VCard
					flat
					class="d-flex flex-column align-center pa-10"
				>
					<HowItWorkProcess
						:text1="$t('views.homeUser.common.icons.signup')"
						:text2="$t('views.homeUser.common.icons.answer')"
						:text3="$t('views.homeUser.employeur.icons.folder')"
						:text4="$t('views.homeUser.common.icons.comment')"
						:text5="$t('views.homeUser.common.icons.decision')"
					/>
					<VRow
						align="center"
						class="d-flex justify-center"
					>
						<VCol
							cols="12"
							md="6"
							class="d-flex justify-center"
						>
							<VBtn
								class="primary mr-2"
								:to="signUpUri"
							>
								{{ $t('views.homeUser.common.banner.signup') }}
							</VBtn>
							<VBtn
								outlined
								:to="signInUri"
							>
								{{ $t('views.homeUser.common.banner.signin') }}
							</VBtn>
						</VCol>
					</VRow>
				</VCard>
			</VContainer>
			<VContainer
				tag="section"
				class="mb-10"
			>
				<VRow justify="center">
					<VCol
						cols="12"
						md="5"
					>
						<VCard
							flat
							color="#E7ECF5"
							class="pa-5"
						>
							<VCardTitle>
								<img
									src="../assets/aide.svg"
									alt="Aide"
									class="mr-2"
								>
								<span>{{ $t('views.homeUser.common.help.title') }}</span>
							</VCardTitle>

							<VCardText class="help-info">
								<VIcon
									size="20px"
									class="mr-2"
								>
									{{ pcIcon }}
								</VIcon>
								<span>
									{{ $t('views.homeUser.common.help.moreInformation') }}
									<a
										target="_blank"
										:href="ameliUri"
									>
										ameli.fr
									</a>
								</span>
								<VIcon
									size="15px"
									class="ml-2"
								>
									{{ extLinkIcon }}
								</VIcon>
							</VCardText>
							<VCardText class="help-info">
								<VIcon
									size="20px"
									class="mr-2"
								>
									{{ telIcon }}
								</VIcon>
								<span>{{ $t('views.homeUser.common.help.phone') }} {{ numTelHelp }}</span>
							</VCardText>
						</VCard>
					</VCol>
				</VRow>
			</VContainer>
		</div>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { RolesEnum } from '@/types/enum/RolesEnum';
	import { mdiLaptop, mdiPhone, mdiOpenInNew, mdiEmail } from '@mdi/js';
	import ConnexionMCE from '@/components/Authentification/ConnexionMCE.vue';
	import HowItWorkProcess from '@/components/Home/HowItWorkProcess.vue';

	const Props = Vue.extend({
		props: {
			userType: {
				type: String,
				required: true
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component<HomeUser>({
		components: {
			ConnexionMCE,
			HowItWorkProcess
		}
	})
	export default class HomeUser extends MixinsDeclaration {
		pcIcon = mdiLaptop;
		extLinkIcon = mdiOpenInNew;
		telIcon = mdiPhone;
		emailIcon = mdiEmail;

		get isSmAndDown(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}

		get isAssure(): boolean {
			return this.userType === RolesEnum.ASSURE;
		}

		get isEmployeurParticulier(): boolean {
			return this.userType === RolesEnum.EMPLOYEUR_PARTICULIER;
		}

		get ameliUri(): string {
			return this.isAssure ? 'https://www.ameli.fr/assure/droits-demarches/maladie-accident-hospitalisation' : 'https://www.ameli.fr/entreprise/vos-salaries';
		}

		get signUpUri(): string {
			return `inscription/${this.userType}`;
		}

		get signInUri(): string {
			return this.isAssure ? 'assure/login' : 'employeur/login';
		}

		get numTelHelp(): string {
			return this.isAssure ? '3646' : '3679';
		}

		get subtitleHowItWorks(): string {
			return this.$t(`views.homeUser.${this.userType}.howItWorks.subTitle`) as string;
		}

		accessInstruction(hasAccount: boolean): string {
			if (hasAccount) {
				return this.isAssure ? this.$t('views.homeUser.assure.hasAccount') : this.$t('views.homeUser.employeur.hasAccount');
			}
			return this.isAssure ? this.$t('views.homeUser.assure.noAccount') : this.$t('views.homeUser.employeur.noAccount');
		}
	}
</script>

<style scoped lang="scss">

/******************
	UTILITIES
*******************/

.word-break {
	word-break: keep-all;
}

.line-height-normal {
	line-height: normal;
}

.white-space-pre-line {
	white-space: pre-line;
}

/******************
	OVERRIDES
*******************/

:deep(.v-card__title) {
	padding: 0 0.5rem 0 0;
	font-weight: bold;
	line-height: 3.3rem;
	color: #0C419A;
}

:deep(.v-card__text) {
	padding: 0;
}

:deep(.v-card) {
	border: solid 1px #F8F9FC;
}

:deep(a) {
	text-transform: none;
	letter-spacing: normal;
}

:deep(.theme--light.v-expansion-panels .v-expansion-panel) {
	background-color: transparent;
	border-bottom: solid 1px #E0E0E0;
}

:deep(.v-expansion-panel-header__icon) {
	margin-left: 1rem;
}

:deep(.v-btn.v-btn--outlined) {
	border: solid 1px #0C419A;
	color: #0C419A;
}

// Mauvaise pratique, mais nécessaire pour surcharger
// un style qui est déjà en !important
.v-application .v-alert {
	background: #F8F9FC !important;
}

/******************
      CLASSES
*******************/

.home-user {
	height: 100%;
	display: flex;
	gap: 2rem;
	justify-content: center;
	padding-top: 5rem;
	background: linear-gradient(#EFF1FC, #fff);
}

.page-wrapper {
	max-width: 1240px;
	display: flex;
	justify-content: center;
	align-content: center;
	flex-direction: column;
}

.icon-base {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.3rem;
	text-align: center;
	font-size: 1rem;
	color: #0C419A;
	font-weight: 500;
	padding-left: 0;
	padding-right: 0;
	margin: 0;

	&--no-padding {
		padding-bottom: 0;
	}
}

.icon-box {
	@extend .icon-base;
	padding: 2rem;
}

.icon-arrow {
	@extend .icon-base;
	padding: 3.3rem;
}

.icon-arrow img {
  min-width: 32px;
  max-width: 100%;
}

.text-top-heading {
	background-color: #0C419A;
	color: #fff;
	padding: 0.5rem;
	font-size: 1rem;
	font-weight: 500;
	width: auto;
}

.banner-left {
	gap: 0.5rem;

	&--gap {
		gap: 1rem;
	}
}

.banner-right {
	justify-content: center;
}

.help-info {
	display: flex;
	align-items: center;
	margin: 1rem 0;
	font-weight: 500;

	span {
		color: #0C419A;
	}
}
</style>
